// extracted by mini-css-extract-plugin
module.exports = {"actions":"AlisaTextField_actions__28p2f","accentLabel":"AlisaTextField_accentLabel__2ZnxS"};